import { Stack, Button } from '@gogame/components';
import { withArrayFormField, FormFieldGroup } from '@gogame/form';

import AdditionalReward from './AdditionalReward';
import { ADDITIONAL_REWARD_CONDITION } from '../constants';

const AdditionalRewards = withArrayFormField({ padding: 0 })(({
  name,
  value = [],
  push,
  remove,
  disabled,
  addRewardLabel = 'Additional reward package',
  rewardPackageLabel = 'Additional reward package',
  rewardConditionLabel = 'Additional reward condition',
  uniqueConditionSelection = false,
  limit = 10,
}) => {
  const handleAdd = () => push({});
  const handleIsConditionDisabled = (opt) => {
    return value.some(
      (reward) => reward[ADDITIONAL_REWARD_CONDITION] === opt.id
    );
  };
  return (
    <Stack spacing={2}>
      {value?.map?.((_, index) => (
        <FormFieldGroup name={`${name}.${index}`}>
          <AdditionalReward
            disabled={disabled}
            onRemove={() => remove(index)}
            isConditionDisabled={
              uniqueConditionSelection ? handleIsConditionDisabled : undefined
            }
            rewardPackageLabel={rewardPackageLabel}
            rewardConditionLabel={rewardConditionLabel}
          />
        </FormFieldGroup>
      ))}
      <Stack sx={{ alignSelf: 'flex-start' }}>
        <Button add onClick={handleAdd} disabled={value?.length >= limit}>
          {addRewardLabel}
        </Button>
      </Stack>
    </Stack>
  );
});

export default AdditionalRewards;
